import React, { useState } from "react";
import axios from 'axios';
import Loginpic from '../../../assets/images/medicine.svg';
import '../../../assets/styles/userprofile.css';
import { Link } from "react-router-dom";

function Login() {

    const [email, setemail] = useState("")
    const [password, setpassword] = useState("")
    function sendData(e) {
        e.preventDefault();
        const newUser = {
            email: email.toLowerCase(),
            password,
        };

        axios
            .post(`${process.env.REACT_APP_API_LINK_PREFIX}api/user/login`, newUser)
            .then((res) => {

                console.log(res.data)
                if(!res.data?.isAdmin){
                    localStorage.setItem("user", res.data.userId)
                    localStorage.setItem("token", res.data.token)
                    window.location.href = '/dashboard';
                }
                else
                {
                    window.location.href = '/adminlogin';
                }
            })
            .catch((err) => {
                alert("Email or Password is worng");
                console.log(err)
            });
    }
    return (
        <section className="hero is-fullheight-with-navbar">
            <div className="hero-body">
                <div className="container">
                    <div className="columns is-vcentered">
                        <div className="column is-5">
                            <figure className="image">
                                <img src={Loginpic} alt="Pipeline SVG" />
                            </figure>
                        </div>
                        <div className="column is-7">
                            <form onSubmit={sendData}>
                                <h1 className='title is-2 has-text-centered'>Login</h1>
                                <div className='columns is-justify-content-center is-mobile mb-0'>
                                    <div className='column is-10'>
                                        <div className="field">
                                            <div className="control has-icons-left ">
                                                <label className="label">Email</label>
                                                <div className="control">
                                                    <input required className="input is-info" type="email" placeholder='Email' onChange={(e) => { setemail(e.target.value) }} />
                                                    <span className="icon is-small is-left">
                                                        <i className="fas fa-envelope"></i>
                                                    </span>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='columns is-justify-content-center is-mobile mb-0'>
                                    <div className='column is-10'>
                                        <div className="field">
                                            <div className="control has-icons-left">

                                                <label className="label">Password</label>
                                                <div className="control">
                                                    <input required className="input is-info" type="password" placeholder='Password' onChange={(e) => { setpassword(e.target.value) }} />
                                                    <span className="icon is-small is-left">
                                                        <i className="fas fa-lock"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-3">
                                    <div className='is-flex columns is-justify-content-center'>
                                        <button type='submit' className='button is-info  but' >Login</button>
                                    </div>
                                    <div>
                                        <center><h1><b>OR</b></h1></center>
                                    </div>
                                    <div className='is-flex columns is-justify-content-center mt-3'>
                                        <Link to='/addkey'><div className='button is-link but' >View Medical Record</div></Link>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );

}

export default Login;

